// extracted by mini-css-extract-plugin
module.exports = {"dots":"FadingDots_dots__3Z9ue","fade":"FadingDots_fade__1G7yM"};